import { memo } from "react";

interface Props {
  label: string;
  onClick: () => void;
}
function AddMoreButton({ label, onClick }: Props) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={onClick} className="cursor-pointer flex items-center justify-start max-w-max">
      <div className="h-6 w-6 rounded-full bg-durotarFire text-white font-bold flex justify-center items-center">
        <p className="my-auto">+</p>
      </div>
      <span className="font-montserrat font-semibold ml-3 text-durotarFire">{label}</span>
    </div>
  );
}

export default memo(AddMoreButton);
